import { ReactNode } from 'react'
import { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: {
    label: string
    onClick: () => void
  }
  iconColor?: string
}

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  iconColor = 'text-gray-400'
}: EmptyStateProps) => {
  return (
    <div className="text-center py-16 px-6 bg-white border-2 border-dashed border-gray-300 rounded-xl">
      {/* Icon */}
      <div className="flex justify-center mb-6">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center">
          <Icon className={`w-10 h-10 ${iconColor}`} strokeWidth={1.5} />
        </div>
      </div>

      {/* Title */}
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        {title}
      </h3>

      {/* Description */}
      <p className="text-gray-600 mb-8 max-w-md mx-auto">
        {description}
      </p>

      {/* Action Button */}
      {action && (
        <button
          onClick={action.onClick}
          className="inline-flex items-center px-6 py-3 font-semibold text-white bg-framed-yellow-600 hover:bg-framed-yellow-700 rounded-xl transition-colors shadow-sm hover:shadow-md"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
